import React from "react";
import { Card } from "@sscs/ui";
import { MalwareInsight } from "../../../types";
import styles from "./details.module.scss";
import PolicyViolations from "./PolicyViolations/PolicyViolations";

type MalwareProps = {
  issue: MalwareInsight;
};

const Malware = ({ issue }: MalwareProps): React.JSX.Element | null => {
  return (
    <div className={styles["description-and-issues-container"]}>
      <Card.Card>
        <Card.Title>{issue.title}</Card.Title>
        <Card.Content>
          <div>{issue.long_description}</div>
        </Card.Content>
      </Card.Card>
      <PolicyViolations
        violations={issue.caused_violations}
        evaluations={issue.risk_assessment_evaluation}
      />
    </div>
  );
};

export default Malware;
